<template>
    <div>

        <loading />
        <header-cna />

        <div class="container pb-5">
            <div class="criar-conta mt-4">
                <h2 class="text-center">
                    <strong>Criar Conta</strong>
                </h2>

                <div class="dados-conta bg-white mt-3 rounded py-5 px-3 p-md-5 shadow">
                    <div class="steps">
                        <form class="form cf">
                            <div class="wizard my-0 mx-auto">
                                <div class="wizard-inner">

                                    <div class="connecting-line"></div>

                                    <div class="connecting-line-status"
                                         v-bind:style="{ width: step.status }"></div>

                                    <ul class="nav nav-tabs">

                                        <li class="nav-item">
                                            <a @click="$event.preventDefault()"
                                               v-bind:class="{ active: step.id == 1 }"
                                               title="step"
                                               class="nav-link">
                                                <span class="round-tab"></span>
                                                <span class="step-text">
                                                    <strong>Identificação</strong>
                                                    <br />
                                                    Qual conta você deseja ativar?
                                                </span>
                                            </a>
                                        </li>

                                        <li class="nav-item">
                                            <a @click="$event.preventDefault()"
                                               v-bind:class="{ active: step.id == 2 }"
                                               title="step"
                                               class="nav-link">
                                                <span class="round-tab"></span>
                                                <span class="step-text">
                                                    <strong>Dados Pessoais</strong>
                                                    <br />
                                                    Queremos saber quem é você :)
                                                </span>
                                            </a>
                                        </li>

                                        <li class="nav-item">
                                            <a @click="$event.preventDefault()"
                                               v-bind:class="{ active: step.id == 3 }"
                                               title="step"
                                               class="nav-link">
                                                <span class="round-tab"></span>
                                                <span class="step-text">
                                                    <strong>Acesso</strong>
                                                    <br />
                                                    Vamos configurar sua forma de acessar
                                                </span>
                                            </a>
                                        </li>

                                        <li class="nav-item">
                                            <a @click="$event.preventDefault()"
                                               v-bind:class="{ active: step.id == 4 }"
                                               title="step"
                                               class="nav-link">
                                                <span class="round-tab"></span>
                                                <span class="step-text">
                                                    <strong>Senha</strong>
                                                    <br />
                                                    Porque segurança é importante pra gente!
                                                </span>
                                            </a>
                                        </li>

                                    </ul>
                                </div>


                                <div class="tab-content">
                                    <div class="tab-pane active" v-if="step.id == 1">
                                        <cadastro-identificacao :model="model" @on-next="stepIdentificacaoFinished($event)" @on-back="goStep('voltar')" />
                                    </div>
                                    <div class="tab-pane active" v-if="step.id == 2">
                                        <cadastro-dados-pessoais :model="model" @on-next="stepDadosPessoaisFinished($event)" @on-back="goStep('identificacao')" />
                                    </div>
                                    <div class="tab-pane active" v-if="step.id == 3">
                                        <cadastro-acesso :model="model" @on-next="stepAcessoFinished($event)" @on-back="goStep('dados-pessoais')" />
                                    </div>
                                    <div class="tab-pane active" v-if="step.id == 4">
                                        <cadastro-senha :model="model" @on-next="stepSenhaFinished($event)" @on-back="goStep('acesso')" />
                                    </div>
                                    <div class="tab-pane active" v-if="step.id == 5">
                                        <cadastro-finalizar :model="model" @on-next="stepFinalizarFinished($event)" />
                                    </div>

                                </div>

                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

    </div>

</template>



<script>
    import Global from '@/common/global'

    import loading from '@/common/components/loading'
    import headerCna from '@/template/header'

    import cadastroAcesso from './acesso'
    import cadastroDadosPessoais from './dados-pessoais'
    import cadastroFinalizar from './finalizar'
    import cadastroIdentificacao from './identificacao'
    import cadastroSenha from './senha'

    export default {
        name: 'pessoa-cna-edit',
        components: {
            headerCna,
            loading,
            cadastroAcesso,
            cadastroDadosPessoais,
            cadastroFinalizar,
            cadastroIdentificacao,
            cadastroSenha
        },
        data: () => ({

            step: {
                id: null,
                status: 0
            },

            model: {}

        }),
        methods: {
            stepIdentificacaoFinished(_data) {
                this.model = _data;
                this.model.password = _data.codigoAcessoUtilizado;
                this.goStep('dados-pessoais')
            },
            stepDadosPessoaisFinished(_data) {
                this.goStep('acesso')
            },
            stepAcessoFinished(_data) {
                if (_data)
                    this.goStep('senha')
            },
            stepSenhaFinished(_data) {
                if (_data)
                    this.goStep('finalizar')
            },
            stepFinalizarFinished(_data) {
                if (_data)
                    this.goStep('finalizar')
            },
            goStep(_step) {

                switch (_step) {
                    case 'voltar':
                        window.location = Global.URL_SHOPPING_CNA;
                        break;
                    case 'identificacao':
                        this.step.name = 'identificacao';
                        this.step.id = 1;
                        this.step.status = '0%';
                        break;
                    case 'dados-pessoais':
                        this.step.name = 'dados-pessoais';
                        this.step.id = 2;
                        this.step.status = '25%';
                        break;
                    case 'acesso':
                        this.step.name = 'acesso';
                        this.step.id = 3;
                        this.step.status = '50%';
                        break;
                    case 'senha':
                        this.step.name = 'senha';
                        this.step.id = 4;
                        this.step.status = '75%';
                        break;
                    case 'finalizar':
                        this.step.name = 'finalizar';
                        this.step.id = 5;
                        this.step.status = '75%';
                        break;
                    default:
                }

            },

        },

        mounted() {
            this.goStep('identificacao')
        }
    };
</script>
